import { AbstractControl, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

export class TicketFormFactory {
    static buildForm(fb: UntypedFormBuilder): UntypedFormGroup {
        return fb.group({
            uid: [null],
            contactUid: [null, Validators.required],
            payMethodUid: [null, Validators.required],
            cashRegisterUid: [null],
            partnerUid: [null],
            bankAccountUid: [null],
            projectUid: [null],
            entranceAccount: [null, Validators.required],
            number: [''],
            date: [new Date(), Validators.required],
            paid: [true],
            notes: [''],
            lines: fb.array([])
        });
    }

    static lines(form: UntypedFormGroup): UntypedFormArray {
        return form.get('lines') as UntypedFormArray;
    }

    static createLine(fb: UntypedFormBuilder): UntypedFormGroup {
        return fb.group({
            conceptUid: [null, Validators.required],
            quantity: [1, Validators.required],
            price: [0, Validators.required],
            discount: [0],
            tax: [[]]
        });
    }

    static getValidationMessages(form: UntypedFormGroup): string[] {
        const messages: string[] = [];

        this.pushIfInvalid(messages, form, 'contactUid', 'Selecciona un contacto.');
        this.pushIfInvalid(messages, form, 'payMethodUid', 'Selecciona el tipo de cobro.');
        this.pushIfInvalid(messages, form, 'date', 'Indica la fecha de cobro.');
        this.pushIfInvalid(messages, form, 'cashRegisterUid', 'Selecciona la caja.');
        this.pushIfInvalid(messages, form, 'bankAccountUid', 'Selecciona la cuenta bancaria.');
        this.pushIfInvalid(messages, form, 'partnerUid', 'Selecciona el socio.');
        this.pushIfInvalid(messages, form, 'entranceAccount', 'Selecciona la cuenta contable de ingreso.');

        const lines = form.get('lines') as UntypedFormArray;
        if (lines && lines.length) {
            for (let i = 0; i < lines.length; i++) {
                const g = lines.at(i) as UntypedFormGroup;
                const lineNumber = i + 1;

                if (this.isRequiredMissing(g.get('conceptUid'))) {
                    messages.push(`Línea ${lineNumber}: selecciona un concepto.`);
                }
                if (this.isRequiredMissing(g.get('quantity'))) {
                    messages.push(`Línea ${lineNumber}: indica la cantidad.`);
                }
                if (this.isRequiredMissing(g.get('price'))) {
                    messages.push(`Línea ${lineNumber}: indica el precio.`);
                }
            }
        }

        return messages.filter((v, i, a) => a.indexOf(v) === i);
    }

    private static pushIfInvalid(out: string[], form: UntypedFormGroup, key: string, msg: string): void {
        const ctrl = form.get(key);
        if (ctrl && ctrl.enabled && ctrl.invalid) out.push(msg);
    }

    private static isRequiredMissing(ctrl: AbstractControl | null): boolean {
        return !!(ctrl && ctrl.errors && ctrl.errors['required']);
    }
}
